<template>
  <div class="flex w-full items-center" style="position: relative;"
    @click.stop
    @click.prevent  
  >
    <div class="flex justify-start items-center" style="padding: 0.1rem;">
      <div style="line-height: 1.2rem;">
        <vs-row>
          <vs-col vw-12><div class="mt-1" >{{ dispDate }}</div></vs-col>
        </vs-row>
        <vs-row>
          <vs-col vw-12><div class="mt-1" >{{ dispTime }}</div></vs-col>
        </vs-row>
      </div>
    </div>
  </div>
</template>

<script>
import { ColorMixin } from "@/mixins";
import moment from "moment-timezone";

export default {
  name: "CellRendererLink",
  mixins: [ColorMixin],
  data() {
    return {
    };
  },
  computed: {
    dispDate() {
      return this.params.value ? moment(this.params.value).format('YYYY/MM/DD') : null;
    },
    dispTime() {
      return this.params.value ? moment(this.params.value).format('HH:mm') : null;
    },
  },
  created() {
  },
};
</script>

